import { useParams } from "react-router-dom";
import { recipes } from "../data/recipes";

const Recipe = () => {
  const { slug } = useParams();
  const recipe = recipes.find(r => r.slug === slug);

  if (!recipe) {
    return <div className="py-24 text-center">Recipe not found</div>;
  }

  return (
    <section className="bg-[#fff9e6] py-16 sm:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">

        {/* IMAGE */}
        <img
          src={recipe.image}
          alt={recipe.title}
          className="w-full h-[260px] sm:h-[360px] md:h-[420px] object-cover rounded-2xl mb-10"
        />

        {/* TITLE */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#b55252] mb-10">
          {recipe.title}
        </h1>

        {/* META */}
        <div className="grid grid-cols-1 sm:grid-cols-3 border border-[#b55252] rounded-xl mb-16 text-center">
          <div className="py-6">
            <p className="font-serif">servings</p>
            <p>{recipe.meta.servings}</p>
          </div>

          <div className="py-6 sm:border-x">
            <p className="font-serif">prep time</p>
            <p>{recipe.meta.prepTime}</p>
          </div>

          <div className="py-6">
            <p className="font-serif">cook time</p>
            <p>{recipe.meta.cookTime}</p>
          </div>
        </div>

        {/* INGREDIENTS */}
        <h2 className="text-2xl sm:text-3xl font-serif text-[#b55252] mb-6">
          Ingredients
        </h2>

        {Object.entries(recipe.ingredients).map(([section, items]) => (
          <div key={section} className="mb-8">
            <h3 className="text-xl sm:text-2xl font-serif text-[#7a7a00] mb-3">
              {section}
            </h3>

            <ul className="space-y-2">
              {items.map((item, i) => (
                <li key={i} className="flex gap-2 text-sm sm:text-base">
                  <span className="text-pink-500">♥</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* INSTRUCTIONS */}
        <h2 className="text-2xl sm:text-3xl font-serif text-[#b55252] mt-16 mb-6">
          Instructions
        </h2>

        <ol className="space-y-4 list-decimal pl-5 sm:pl-6 text-base sm:text-lg text-gray-700">
          {recipe.instructions.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ol>

      </div>
    </section>
  );
};

export default Recipe;
